<ng-container *ngIf="location else noLocation">
    <div class="accordion accordion-flush" id="locationMeterAccordion">
        <div class="accordion-item">
            <h2 class="accordion-header">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#electricityMeterCollapse" aria-expanded="false"
                        aria-controls="electricityMeterCollapse">
                    <div class="row p-0 w-100 pe-3 g-0">
                        <app-connection-image [connectionType]="'Electricity'" class="col-auto"></app-connection-image>
                        <span class="col">Electricity meters</span>
                        <span class="col-auto notranslate">{{getMetersForConnectionType('Electricity', true).length + getMetersForConnectionType('Electricity', false).length}}</span>
                    </div>
                </button>
            </h2>
            <div id="electricityMeterCollapse" class="accordion-collapse collapse"
                 data-bs-parent="#locationMeterAccordion">
                <div class="accordion-body">
                    <ul class="list-group list-group-flush">
                        <ng-container *ngFor="let meter of getMetersForConnectionType('Electricity', true); trackBy : trackBy">
                            <li class="py-1 list-group-item d-flex align-items-center hover-show">
                                <app-connection-image [connectionType]="'Electricity'" class="col-auto ms-2"></app-connection-image>
                                <span class="notranslate">{{refDataUtils.meterFormatter(meter)}}</span>
                                <button *ngIf="appContext.isManagerForEntity(location)"
                                        type="button" class="btn position-absolute end-0 to-show" role="button"
                                        aria-expanded="false" (click)="editMeter(meter)">
                                    <i class="bi bi-pencil"></i>
                                </button>
                            </li>
                        </ng-container>
                        <ng-container *ngFor="let subMeter of getMetersForConnectionType('Electricity', false); trackBy : trackBy">
                            <li class="py-1 list-group-item d-flex align-items-center hover-show">
                                <app-meter-image [connectionType]="subMeter.connection.info.connectionType"
                                                 [meterType]="subMeter.meter.details?.type || subMeter.meter.info.type"
                                                 class="d-inline-block ms-2"></app-meter-image>
                                <span class="notranslate">{{refDataUtils.meterFormatter(subMeter)}}</span>
                                <button *ngIf="appContext.isManagerForEntity(location)"
                                        type="button" class="btn position-absolute end-0 to-show" role="button"
                                        aria-expanded="false" (click)="editMeter(subMeter)">
                                    <i class="bi bi-pencil"></i>
                                </button>
                            </li>
                        </ng-container>
                    </ul>
                </div>
            </div>
        </div>
        <div class="accordion-item">
            <h2 class="accordion-header">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#gasMeterCollapse" aria-expanded="false" aria-controls="gasMeterCollapse">
                    <div class="row p-0 w-100 pe-3 g-0">
                        <app-connection-image [connectionType]="'Gas'" class="col-auto"></app-connection-image>
                        <span class="col">Gas/Heat meters</span>
                        <span class="col-auto notranslate">{{getMetersForConnectionType('Gas', true).length + getMetersForConnectionType('Heat', true).length}}</span>
                    </div>
                </button>
            </h2>
            <div id="gasMeterCollapse" class="accordion-collapse collapse" data-bs-parent="#locationMeterAccordion">
                <div class="accordion-body">
                    <ul class="list-group list-group-flush">
                        <ng-container *ngFor="let meter of getMetersForConnectionType('Gas', true); trackBy : trackBy">
                            <li class="py-1 list-group-item d-flex align-items-center hover-show">
                                <app-connection-image [connectionType]="'Gas'" class="col-auto ms-2"></app-connection-image>
                                <span class="notranslate">{{refDataUtils.meterFormatter(meter)}}</span>
                                <button *ngIf="appContext.isManagerForEntity(location)"
                                        type="button" class="btn position-absolute end-0 to-show" role="button"
                                        aria-expanded="false" (click)="editMeter(meter)">
                                    <i class="bi bi-pencil"></i>
                                </button>
                            </li>
                        </ng-container>
                        <ng-container *ngFor="let subMeter of getMetersForConnectionType('Heat', true); trackBy : trackBy">
                            <li class="py-1 list-group-item d-flex align-items-center hover-show">
                                <app-connection-image [connectionType]="'Heat'" class="col-auto ms-2"></app-connection-image>
                                <span class="notranslate">{{refDataUtils.meterFormatter(subMeter)}}</span>
                                <button *ngIf="appContext.isManagerForEntity(location)"
                                        type="button" class="btn position-absolute end-0 to-show" role="button"
                                        aria-expanded="false" (click)="editMeter(subMeter)">
                                    <i class="bi bi-pencil"></i>
                                </button>
                            </li>
                        </ng-container>
                    </ul>
                </div>
            </div>
        </div>
        <div class="accordion-item">
            <h2 class="accordion-header">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#waterMeterCollapse" aria-expanded="false" aria-controls="waterMeterCollapse">
                    <div class="row p-0 w-100 pe-3 g-0">
                        <app-connection-image [connectionType]="'Water'" class="col-auto"></app-connection-image>
                        <span class="col">Water meters</span>
                        <span class="col-auto notranslate">{{getMetersForConnectionType('Water', true).length + getMetersForConnectionType('Water', false).length}}</span>
                    </div>
                </button>
            </h2>
            <div id="waterMeterCollapse" class="accordion-collapse collapse" data-bs-parent="#locationMeterAccordion">
                <div class="accordion-body">
                    <ul class="list-group list-group-flush">
                        <ng-container *ngFor="let meter of getMetersForConnectionType('Water', true); trackBy : trackBy">
                            <li class="py-1 list-group-item d-flex align-items-center hover-show">
                                <app-connection-image [connectionType]="'Water'" class="col-auto ms-2"></app-connection-image>
                                <span class="notranslate">{{refDataUtils.meterFormatter(meter)}}</span>
                                <button *ngIf="appContext.isManagerForEntity(location)"
                                        type="button" class="btn position-absolute end-0 to-show" role="button"
                                        aria-expanded="false" (click)="editMeter(meter)">
                                    <i class="bi bi-pencil"></i>
                                </button>
                            </li>
                        </ng-container>
                        <ng-container *ngFor="let subMeter of getMetersForConnectionType('Water', false); trackBy : trackBy">
                            <li class="py-1 list-group-item d-flex align-items-center hover-show">
                                <app-meter-image [connectionType]="subMeter.connection.info.connectionType"
                                                 [meterType]="subMeter.meter.details?.type || subMeter.meter.info.type" class="d-inline-block ms-2"></app-meter-image>
                                <span class="notranslate">{{refDataUtils.meterFormatter(subMeter)}}</span>
                                <button *ngIf="appContext.isManagerForEntity(location)"
                                        type="button" class="btn position-absolute end-0 to-show" role="button"
                                        aria-expanded="false" (click)="editMeter(subMeter)">
                                    <i class="bi bi-pencil"></i>
                                </button>
                            </li>
                        </ng-container>
                    </ul>
                </div>
            </div>
        </div>

        <div class="accordion-item">
            <h2 class="accordion-header">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#chargePointMeterCollapse" aria-expanded="false" aria-controls="chargePointMeterCollapse">
                    <div class="row p-0 w-100 pe-3 g-0">
                        <app-connection-image [connectionType]="'ChargePoint'" class="col-auto"></app-connection-image>
                        <span class="col">Charge Points</span>
                        <span class="col-auto notranslate">{{getMetersForConnectionType('ChargePoint', true).length + getMetersForConnectionType('ChargePoint', false).length}}</span>
                    </div>
                </button>
            </h2>
            <div id="chargePointMeterCollapse" class="accordion-collapse collapse" data-bs-parent="#locationMeterAccordion">
                <div class="accordion-body">
                    <ul class="list-group list-group-flush">
                        <ng-container *ngFor="let meter of getMetersForConnectionType('ChargePoint', true); trackBy : trackBy">
                            <li class="py-1 list-group-item d-flex align-items-center hover-show">
                                <app-meter-image [connectionType]="meter.connection.info.connectionType"
                                                 [meterType]="meter.meter.details?.type || meter.meter.info?.type"
                                                 [virtual]="meter.meter.info.virtual" class="d-inline-block ms-2">
                                </app-meter-image>
                                <span class="notranslate">{{refDataUtils.meterFormatter(meter)}}</span>
                                <button *ngIf="appContext.isManagerForEntity(location)"
                                        type="button" class="btn position-absolute end-0 to-show" role="button"
                                        aria-expanded="false" (click)="editMeter(meter)">
                                    <i class="bi bi-pencil"></i>
                                </button>
                            </li>
                        </ng-container>
                        <ng-container *ngFor="let subMeter of getMetersForConnectionType('ChargePoint', false); trackBy : trackBy">
                            <li class="py-1 list-group-item d-flex align-items-center hover-show">
                                <app-meter-image [connectionType]="subMeter.connection.info.connectionType"
                                                 [meterType]="subMeter.meter.details?.type || subMeter.meter.info.type"
                                                 class="d-inline-block ms-2"></app-meter-image>
                                <span class="notranslate">{{refDataUtils.meterFormatter(subMeter)}}</span>
                                <button *ngIf="appContext.isManagerForEntity(location)"
                                        type="button" class="btn position-absolute end-0 to-show" role="button"
                                        aria-expanded="false" (click)="editMeter(subMeter)">
                                    <i class="bi bi-pencil"></i>
                                </button>
                            </li>
                        </ng-container>
                    </ul>
                </div>
            </div>
        </div>

    </div>
</ng-container>
<ng-template #noLocation>
    <div class="card-subtitle">
        <h2>No location selected</h2>
    </div>
</ng-template>